import { Outlet } from "react-router-dom";
import useAuthUser from "../../hooks/useAuthUser";

// Grievance Management is only for Admin, HR Manager, Manager and Employee.
// The backend rejects every other role too — this just avoids showing them a
// broken screen if they reach the URL directly.
const GrievanceRoot = () => {
  const { loggedInUser, canAccessGrievance } = useAuthUser();

  // The logged-in user is decoded from the token in an effect, so it's null
  // for the very first render.
  if (!loggedInUser) return null;

  if (!canAccessGrievance) {
    return (
      <div style={{ padding: "24px" }}>
        <p>You are not allowed to access Grievance Management.</p>
      </div>
    );
  }

  return <Outlet />;
};

export default GrievanceRoot;
